import React, { ChangeEvent, FC, useContext } from "react";
import { Pagination, Box, Grid, TablePagination } from "@mui/material";
import { LanguageContext } from "common/contexts/LanguageContext";

interface IProps {
  rowsPerPageOptions: number[];
  count: number;
  rowsPerPage: number;
  page: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: ChangeEvent<HTMLInputElement>) => void;
}
const CustomTablePagination: FC<IProps> = (props) => {
  const { rowsPerPageOptions, count, rowsPerPage, page, onPageChange, onRowsPerPageChange } = props;

  const { getString } = useContext(LanguageContext);

  const handleChangePage = (event: unknown, newPage: number) => {
    onPageChange(event, newPage - 1);
  };

  return (
    <Box>
      <Grid container spacing={1} >
        <Grid item xs={4}></Grid>
        <Grid item xs={4} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Pagination count={Math.ceil(count / rowsPerPage)} page={page + 1} onChange={handleChangePage} />
        </Grid>
        <Grid item xs={4} sx={{overflow: "visible"}}>
          <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            count={count}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            page={page}
            onRowsPerPageChange={onRowsPerPageChange}
            ActionsComponent={() => <span />}
            labelRowsPerPage={`${getString("tbl_proj_pagination")}:`}
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${getString("tbl_proj_of")} ${count}`}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CustomTablePagination;
